import React from 'react';
import { connect } from 'react-redux';
import i18next from 'i18next';

import { CommentOptions } from '~src/interfaces/question.interface';
import { Scale } from '~src/interfaces/scale.interface';
import { Topic } from '~src/interfaces/topic.interface';
import { StoreI } from '~src/rootReducer';
import LoadingSpinner from '~src/shared/loadingSpinner/LoadingSpinner';
import { TopicCreate, addTopic } from '~src/modules/topics/actions/topicActions';
import { Survey } from '~src/modules/surveys/interfaces';
import ListAddForm from '~src/modules/surveys/components/topic_select/ListAddForm';
import { ApiReduxResp } from '~src/services/apiMiddleware';

import { AddFormWrapper } from './topicQuestionsForm.sc';

interface DispatchProps {
  addTopic: (topic: TopicCreate) => ApiReduxResp<Topic>;
}

interface StateProps {
  loadingScales: boolean;
  scalesArr: Scale[];
}

interface OwnProps {
  defaultContentLocale: string;
  survey: Survey;
  t: i18next.TFunction;
  createTopic: (topicId: string) => void;
}

type Props = DispatchProps & StateProps & OwnProps;

class SurveyTopicAdd extends React.Component<Props> {
  addTopic = (value: string): ApiReduxResp<Topic> => {
    return new Promise((res, rej) => {
      this.props
        .addTopic({
          name: { [this.props.defaultContentLocale]: value },
          subject: this.props.survey.subject,
          comments: CommentOptions.Optional,
          scaleId: this.props.scalesArr[0].id,
        })
        .then((resp) => {
          if (resp.response) {
            this.props.createTopic(resp.response.data.id);
            res(resp);
          } else {
            rej(resp);
          }
        })
        .catch((err) => {
          rej(err);
        });
    });
  };

  render = () => (
    <AddFormWrapper>
      {this.props.loadingScales ? (
        <LoadingSpinner />
      ) : (
        <ListAddForm
          inputLabelKey="x.survey.details.topic.form.add.topic.label"
          addTextKey="x.survey.details.topic.form.add.topic.button"
          submitForm={this.addTopic}
        />
      )}
    </AddFormWrapper>
  );
}

const mapStateToProps = (state: StoreI): StateProps => ({
  scalesArr: state.scales.items,
  loadingScales: state.scales.loadingScales,
});

const mapDispatchToProps = (dispatch: any): DispatchProps => ({
  addTopic: (topic: TopicCreate) => dispatch(addTopic(topic)),
});

const SurveyTopicAddSuper = connect(mapStateToProps, mapDispatchToProps)(SurveyTopicAdd);

export default SurveyTopicAddSuper;
